import { apiClient } from '@app/lib'
import { type SugarAttestationPeriodInput, type SugarSaveAttestationPeriodResponse } from '@app/types'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const useSaveAttestationPeriod = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['saveAttestationPeriod'],
    mutationFn: async (input: SugarAttestationPeriodInput) => {
      const { data } = await apiClient.post<SugarSaveAttestationPeriodResponse>('/api/attestation-periods', input, {
        timeout: 60_000 // 1 minute
      })

      return data
    },
    onSuccess: async (data) => {
      const { attestationPeriodId, schoolYearId } = data.data

      queryClient.setQueryData(['attestationPeriods', { attestationPeriodId }], data.data)

      await queryClient.invalidateQueries({
        queryKey: ['attestationPeriods', { schoolYearId }]
      })

      return data
    }
  })
}
